import { render, staticRenderFns } from "./DownloadLink.vue?vue&type=template&id=7d0d0d9a&scoped=true&"
import script from "./DownloadLink.vue?vue&type=script&lang=js&"
export * from "./DownloadLink.vue?vue&type=script&lang=js&"
import style0 from "./DownloadLink.vue?vue&type=style&index=0&id=7d0d0d9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0d0d9a",
  null
  
)

export default component.exports